import React, { ReactElement } from "react";
import { twJoin, twMerge } from "tailwind-merge";

import { SupAsset } from "../../../components/UI/Tag/Asset";

export interface AssetPairProps {
  className?: string;
  logo: string | ReactElement;
  alt?: string;
  pairLogo?: string | ReactElement;
  pairAlt?: string;
  pairPosition?: "left" | "right";
  small?: boolean;
}

export function SupAssetPair({ className, small = false, logo, alt, pairLogo, pairAlt, pairPosition = "right" }: AssetPairProps) {
  return (
    <div className={twMerge("sup-asset-pair inline-flex relative", className)}>
      <SupAsset logo={logo} alt={alt} size={small ? "lg" : "xl"} />
      {pairLogo && <SupAsset logo={pairLogo} alt={pairAlt} size={small ? "xs" : "sm"} className={twJoin("absolute bottom-0 bg-neutral-950", pairPosition === "left" ? "left-0" : "right-0")} />}
    </div>
  );
}
